import './style.css'

// ══════════════════════════════════════════════════
// NAVIGATION — smooth scroll & active state
// ══════════════════════════════════════════════════
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    document.querySelectorAll('.nav-link').forEach(l => l.classList.remove('active'))
    this.classList.add('active')
    const target = document.querySelector(this.getAttribute('href'))
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })
})

// Header opacity on scroll
window.addEventListener('scroll', () => {
  const header = document.querySelector('.header')
  header.style.background = window.scrollY > 80
    ? 'rgba(7, 9, 15, 0.99)'
    : 'rgba(11, 15, 24, 0.95)'
  updateActiveNavLink()
})

function updateActiveNavLink () {
  const sections = document.querySelectorAll('section[id]')
  const navLinks = document.querySelectorAll('.nav-link')
  let current = ''
  sections.forEach(sec => {
    if (window.scrollY >= sec.offsetTop - 110) current = sec.getAttribute('id')
  })
  navLinks.forEach(link => {
    link.classList.toggle('active', link.getAttribute('href') === `#${current}`)
  })
}

document.addEventListener('DOMContentLoaded', updateActiveNavLink)

// ══════════════════════════════════════════════════
// SCROLL REVEAL
// ══════════════════════════════════════════════════
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1'
      entry.target.style.transform = 'translateY(0)'
    }
  })
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' })

document.querySelectorAll('.service-card, .blog-card, .about-text, .about-stats, .contact-form').forEach(el => {
  el.style.opacity = '0'
  el.style.transform = 'translateY(28px)'
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease'
  observer.observe(el)
})

// Hero CTA → scroll to services
document.querySelector('.hero-cta').addEventListener('click', () => {
  document.querySelector('#services').scrollIntoView({ behavior: 'smooth' })
})

// ══════════════════════════════════════════════════
// CONTACT FORM
// ══════════════════════════════════════════════════
document.querySelector('.contact-form form').addEventListener('submit', async function (e) {
  e.preventDefault()

  const nom              = this.querySelector('input[name="nom"]').value || ''
  const email            = this.querySelector('input[name="email"]').value || ''
  const typeContact      = this.querySelector('select[name="typeContact"]').value || ''
  const entreprise       = this.querySelector('input[name="entreprise"]').value || ''
  const message          = this.querySelector('textarea[name="message"]').value || ''

  const button       = this.querySelector('button')
  const originalText = button.textContent
  button.textContent = currentLang === 'fr' ? 'Envoi en cours…' : 'Sending…'
  button.disabled    = true
  button.style.background = 'linear-gradient(135deg, #ff9500, #ff6b00)'

  try {
    const response = await fetch('http://localhost:3003/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ nom, email, typeContact, entreprise, message })
    })
    const result = await response.json()

    if (result.success) {
      button.textContent      = currentLang === 'fr' ? 'Message envoyé !' : 'Message sent!'
      button.style.background = 'linear-gradient(135deg, #28a745, #20c997)'
      setTimeout(() => {
        button.textContent      = originalText
        button.disabled         = false
        button.style.background = 'linear-gradient(135deg, #00d4ff, #0090bf)'
        this.reset()
      }, 3000)
    } else {
      throw new Error(result.error || 'Server error')
    }
  } catch (err) {
    console.error('Contact form error:', err)
    button.textContent      = currentLang === 'fr' ? 'Serveur indisponible…' : 'Server unavailable…'
    button.style.background = 'linear-gradient(135deg, #ffc107, #ff8800)'

    setTimeout(() => {
      const typeLabel = { ia: 'IA / ML', dev: 'Développement', cloud: 'Cloud & DevOps', conseil: 'Conseil' }[typeContact] || 'Non spécifié'
      const subject = `Contact OAI NOVAX — ${nom}`
      const body = `Nom: ${nom}\nEmail: ${email}\nBesoin: ${typeLabel}\nEntreprise: ${entreprise}\n\nMessage:\n${message}\n\n---\nDepuis oainovax.com (serveur indisponible)`
      window.location.href = `mailto:contact@oainovax.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
      button.textContent = currentLang === 'fr' ? 'Client email ouvert !' : 'Email client opened!'
      button.style.background = 'linear-gradient(135deg, #007bff, #0056b3)'
      setTimeout(() => {
        button.textContent      = originalText
        button.disabled         = false
        button.style.background = 'linear-gradient(135deg, #00d4ff, #0090bf)'
        this.reset()
      }, 3000)
    }, 1000)
  }
})

// ══════════════════════════════════════════════════
// TRANSLATIONS
// ══════════════════════════════════════════════════
const translations = {
  fr: {
    nav_home:     'Accueil',
    nav_services: 'Services',
    nav_about:    'À propos',
    nav_blog:     'Blog',
    nav_contact:  'Contact',

    hero_badge:         'Conseil \u00b7 Ing\u00e9nierie \u00b7 IA G\u00e9n\u00e9rative',
    hero_title:         'Conseil et ing\u00e9nierie IA op\u00e9rationnelle pour l\'entreprise',
    hero_subtitle:      'Nous concevons, d\u00e9ployons et industrialisons vos solutions d\'IA g\u00e9n\u00e9rative \u2014 des syst\u00e8mes multi-agents aux automatisations m\u00e9tier.',
    hero_cta:           'D\u00e9couvrir nos services',
    hero_cta_secondary: 'Parler \u00e0 un expert',

    services_title: "Nos Services",
    services_subtitle: "Des solutions technologiques adapt\u00e9es \u00e0 vos ambitions.",

    service1_title: "Audit IA & Strat\u00e9gie LLM",
    service1_desc: "Cartographie de vos workflows, identification des cas d'usage prioritaires et recommandation du mod\u00e8le adapt\u00e9 \u00e0 vos contraintes.",

    service2_title: "D\u00e9ploiement LLM en Production",
    service2_desc: "Int\u00e9gration sur-mesure de mod\u00e8les de langage dans votre SI avec un focus sur la s\u00e9curit\u00e9, le RAG et l'optimisation des co\u00fbts.",

    service3_title: "Optimisation Assistants IA",
    service3_desc: "Configuration avanc\u00e9e de Claude Code, GitHub Copilot, Cursor : instruction files, prompt files, skills, agents et workflows pour maximiser la productivit\u00e9 de vos d\u00e9veloppeurs.",

    service4_title: "Syst\u00e8mes Multi-Agents",
    service4_desc: "Architecture et impl\u00e9mentation production-grade de syst\u00e8mes o\u00f9 plusieurs agents IA coop\u00e8rent pour livrer des workflows m\u00e9tier complets.",

    service5_title: "Formation & Enablement",
    service5_desc: "Mont\u00e9e en comp\u00e9tence de vos \u00e9quipes sur les LLMs, le prompt engineering et les bonnes pratiques de l'IA g\u00e9n\u00e9rative.",

    service6_title: "D\u00e9veloppement AI-Native",
    service6_desc: "Conception de produits m\u00e9tier de bout en bout, propuls\u00e9s par les LLMs les plus performants du march\u00e9.",

    about_title: "Notre Expertise",
    about_desc1: "Notre \u00e9quipe op\u00e8re quotidiennement sur l'\u00e9cosyst\u00e8me Claude (Anthropic), qui offre \u00e0 ce jour la combinaison la plus mature de raisonnement, s\u00e9curit\u00e9 et conformit\u00e9 RGPD pour l'entreprise europ\u00e9enne.",
    about_desc2: "Nous accompagnons \u00e9galement nos clients sur d'autres mod\u00e8les (OpenAI, Mistral, open-source) lorsque leur architecture l'exige. Pr\u00e9f\u00e9rer un mod\u00e8le n'est pas l'imposer.",

    stat1_label: 'Projets Livrés',
    stat2_label: 'Clients Satisfaits',
    stat3_label: 'Experts IA',
    stat4_label: 'Années d\'expérience',

    blog_title:    'BLOG & ACTUALITÉS',
    blog_subtitle: 'Nos dernières réflexions sur l\'IA et l\'innovation digitale.',
    blog_read_more: 'Lire l\'article',

    contact_title:       'Prêt à démarrer un projet ?',
    contact_description: 'Contactez-nous pour discuter de vos besoins. Nous sommes là pour accélérer votre transition vers l\'IA.<br /><br />Décrivez-nous votre besoin et nous reviendrons vers vous sous 24h.',
    form_name:        'Nom',
    form_email:       'Email',
    form_iam:         'Objet de votre demande',
    form_ai:          'Intelligence Artificielle / ML',
    form_dev:         'Systèmes Multi-Agents',
    form_cloud:       'LLM & RAG',
    form_consulting:  'Automations Claude',
    form_company:     'Entreprise',
    form_message:     'Décrivez votre projet...',
    form_submit:      'Envoyer le message',

    footer_copyright: '© 2026 OAI NOVAX. Tous droits réservés.'
  },

  en: {
    nav_home:     'Home',
    nav_services: 'Services',
    nav_about:    'About',
    nav_blog:     'Blog',
    nav_contact:  'Contact',

    hero_badge:         'Consulting \u00b7 Engineering \u00b7 Generative AI',
    hero_title:         'AI consulting and operational engineering for the enterprise',
    hero_subtitle:      'We design, deploy and industrialize your generative AI solutions \u2014 from multi-agent systems to business automations.',
    hero_cta:           'Discover our services',
    hero_cta_secondary: 'Talk to an expert',

    services_title: "Our Services",
    services_subtitle: "Technological solutions tailored to your ambitions.",

    service1_title: "AI Audit & LLM Strategy",
    service1_desc: "Workflow mapping, priority use case identification and model recommendation adapted to your constraints.",

    service2_title: "LLM Production Deployment",
    service2_desc: "Custom integration of language models into your IT system with a focus on security, RAG and cost optimization.",

    service3_title: "AI Assistants Optimization",
    service3_desc: "Advanced configuration of Claude Code, GitHub Copilot, Cursor: instruction files, prompt files, skills, agents and workflows to maximize your developers' productivity.",

    service4_title: "Multi-Agent Systems",
    service4_desc: "Production-grade architecture and implementation of systems where multiple AI agents cooperate to deliver complete business workflows.",

    service5_title: "Training & Enablement",
    service5_desc: "Upskilling your teams on LLMs, prompt engineering and generative AI best practices.",

    service6_title: "AI-Native Development",
    service6_desc: "End-to-end design of business products powered by the market's most performant LLMs.",

    about_title: "Our Expertise",
    about_desc1: "Our team operates daily on the Claude (Anthropic) ecosystem, which currently offers the most mature combination of reasoning, security and GDPR compliance for European enterprises.",
    about_desc2: "We also support our clients on other models (OpenAI, Mistral, open-source) when their architecture requires it. Preferring a model doesn't mean imposing it.",
    stat1_label: 'Projects Delivered',
    stat2_label: 'Satisfied Clients',
    stat3_label: 'AI Experts',
    stat4_label: 'Years of experience',

    blog_title:    'BLOG & NEWS',
    blog_subtitle: 'Our latest thoughts on AI and digital innovation.',
    blog_read_more: 'Read article',

    contact_title:       'Ready to start a project?',
    contact_description: 'Contact us to discuss your needs. We are here to accelerate your transition to AI.<br /><br />Describe your need and we will get back to you within 24h.',
    form_name:        'Name',
    form_email:       'Email',
    form_iam:         'Subject of your request',
    form_ai:          'Artificial Intelligence / ML',
    form_dev:         'Multi-Agent Systems',
    form_cloud:       'LLM & RAG',
    form_consulting:  'Claude Automations',
    form_company:     'Company',
    form_message:     'Describe your project...',
    form_submit:      'Send message',

    footer_copyright: '© 2026 OAI NOVAX. All rights reserved.'
  }
}

let currentLang = 'fr'

function translatePage (lang) {
  currentLang = lang

  document.querySelectorAll('[data-lang-key]').forEach(el => {
    const key = el.getAttribute('data-lang-key')
    const val = translations[lang]?.[key]
    if (!val) return
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      el.placeholder = val
    } else if (el.tagName === 'OPTION') {
      el.textContent = val
    } else {
      el.innerHTML = val
    }
  })

  // Update lang toggle button
  document.querySelectorAll('.lang-toggle').forEach(toggle => {
    toggle.querySelector('.flag-icon').textContent = lang === 'fr' ? '🇫🇷' : '🇺🇸'
    toggle.querySelector('.lang-text').textContent  = lang === 'fr' ? 'FR' : 'EN'
  })

  // Update active option
  document.querySelectorAll('.lang-option').forEach(btn => {
    btn.classList.toggle('active', btn.getAttribute('data-lang') === lang)
  })

  // Update URL
  updateURL(lang)

  // Close all dropdowns
  document.querySelectorAll('.language-dropdown').forEach(d => d.classList.remove('open'))

  // Persist choice
  localStorage.setItem('oainovax_lang', lang)
}

function updateURL (lang) {
  const path = window.location.pathname
  let newPath
  if (lang === 'en') {
    newPath = path.startsWith('/en') ? path : '/en' + (path === '/' ? '' : path)
  } else {
    newPath = path.startsWith('/en') ? (path.substring(3) || '/') : path
  }
  const newURL = newPath + window.location.search + window.location.hash
  if (newURL !== window.location.pathname + window.location.search + window.location.hash) {
    history.pushState({ lang }, '', newURL)
  }
}

function detectLangFromURL () {
  return window.location.pathname.startsWith('/en') ? 'en' : null
}

// ══════════════════════════════════════════════════
// INIT
// ══════════════════════════════════════════════════
document.addEventListener('DOMContentLoaded', () => {
  // Language init
  const lang = detectLangFromURL() || localStorage.getItem('oainovax_lang') || 'fr'
  translatePage(lang)

  // Language dropdown toggles
  document.querySelectorAll('.lang-toggle').forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.stopPropagation()
      const dropdown = toggle.closest('.language-dropdown')
      dropdown.classList.toggle('open')
      document.querySelectorAll('.language-dropdown').forEach(d => {
        if (d !== dropdown) d.classList.remove('open')
      })
    })
  })
  document.addEventListener('click', () => {
    document.querySelectorAll('.language-dropdown').forEach(d => d.classList.remove('open'))
  })
  document.querySelectorAll('.lang-option').forEach(btn => {
    btn.addEventListener('click', () => translatePage(btn.getAttribute('data-lang')))
  })

  // Browser back/forward
  window.addEventListener('popstate', () => translatePage(detectLangFromURL() || 'fr'))

  // Mobile burger
  const toggle  = document.querySelector('.mobile-menu-toggle')
  const overlay = document.querySelector('.mobile-menu-overlay')
  if (toggle && overlay) {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('active')
      overlay.classList.toggle('active')
      document.body.style.overflow = overlay.classList.contains('active') ? 'hidden' : ''
    })
    document.querySelectorAll('.mobile-nav-menu .nav-link').forEach(link => {
      link.addEventListener('click', () => {
        toggle.classList.remove('active')
        overlay.classList.remove('active')
        document.body.style.overflow = ''
      })
    })
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        toggle.classList.remove('active')
        overlay.classList.remove('active')
        document.body.style.overflow = ''
      }
    })
  }
})

console.log('OAI NOVAX site loaded.')
